module.exports = __webpack_public_path__ + "static/media/headshot-circle.b4404cf8.png";